import React from 'react';
import { Project } from '../../../lib/types';
import { Input } from '../../../components/ui/Input';
import { Textarea } from '../../../components/ui/Textarea';
interface SEOTabProps {
  project: Project;
  updateField: (field: keyof Project, value: any) => void;
}
export function SEOTab({
  project,
  updateField
}: SEOTabProps) {
  return <div className="space-y-12 pb-24 max-w-3xl" data-id="element-1089">
      <section className="space-y-6" data-id="element-1090">
        <div className="border-b border-border pb-2" data-id="element-1091">
          <h2 className="font-display text-2xl font-bold" data-id="element-1092">
            Search Engine Optimization
          </h2>
          <p className="font-mono text-xs text-muted-foreground mt-1" data-id="element-1093">
            Manage how this project appears in search results.
          </p>
        </div>

        <Input label="URL Slug" value={project.slug} onChange={e => updateField('slug', e.target.value)} placeholder="e.g. fintech-trading-platform" data-id="element-1094" />

        <Input label="SEO Title" value={project.seoTitle} onChange={e => updateField('seoTitle', e.target.value)} placeholder="Title for search engines (defaults to Project Title)" data-id="element-1095" />

        <Textarea label="SEO Description" value={project.seoDescription} onChange={e => updateField('seoDescription', e.target.value)} placeholder="Meta description for search results" rows={3} data-id="element-1096" />
      </section>

      <section className="space-y-6" data-id="element-1097">
        <div className="border-b border-border pb-2" data-id="element-1098">
          <h2 className="font-display text-2xl font-bold" data-id="element-1099">Social Sharing</h2>
          <p className="font-mono text-xs text-muted-foreground mt-1" data-id="element-1100">
            Manage how this project appears when shared on social media.
          </p>
        </div>

        <Input label="Open Graph Image URL" value={project.ogImage} onChange={e => updateField('ogImage', e.target.value)} placeholder="https://..." data-id="element-1101" />

        {project.ogImage && <div className="mt-4 border border-border p-2 bg-card" data-id="element-1102">
            <img src={project.ogImage} alt="OG preview" className="w-full h-48 object-cover" data-id="element-1103" />
          </div>}
      </section>

      <section className="space-y-6" data-id="element-1104">
        <div className="border-b border-border pb-2" data-id="element-1105">
          <h2 className="font-display text-2xl font-bold" data-id="element-1106">Visibility</h2>
        </div>

        <label className="flex items-center gap-3 p-4 border border-border bg-card cursor-pointer hover:border-primary transition-colors" data-id="element-1107">
          <input type="checkbox" checked={project.featured} onChange={e => updateField('featured', e.target.checked)} className="w-4 h-4 accent-primary" data-id="element-1108" />
          <div data-id="element-1109">
            <p className="font-mono text-sm font-bold uppercase tracking-widest" data-id="element-1110">
              Featured Project
            </p>
            <p className="font-mono text-xs text-muted-foreground mt-1" data-id="element-1111">
              Show this project prominently on the homepage.
            </p>
          </div>
        </label>
      </section>
    </div>;
}